var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('extended-report',{key:_vm.componentKey,staticClass:"extend-report--affiliate",attrs:{"attach-class":`.extend-report--affiliate`}})
}
var staticRenderFns = []

export { render, staticRenderFns }